import Span from '@/components/common/textElements/Span.tsx'
import { TextElementProps } from '@/components/common/textElements/Paragraph.tsx'
import { CurrStageData } from '@/lib/actions/getCurrStage.ts'
import getStageIdString from '@/lib/helpers/getStageIdString.ts'

type PropsT = {
  stage?: CurrStageData | null
  fullNumber?: boolean
} & TextElementProps

export default function StageNumberSpan({
  variant = 'muted',
  className,
  stage,
  size,
  fullNumber = true,
}: PropsT) {
  if (!stage) return

  return (
    <>
      <Span size={size} className={className} variant={variant}>
        {getStageIdString(stage, fullNumber)}
      </Span>
    </>
  )
}
